<template>
  <div class="mod-joylearning__offringlist}">
    <div class="pkg-search-box">
      <el-form
        class="pkg-content"
        label-width="auto"
        label-position="top"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-row class="search-box">
          <el-col :span="18">
            <el-row class="margb10">
              <el-col :span="8">
                <el-form-item prop="courseCode" class="search-item">
                  <span slot="label">
                    <el-link type="primary" :underline="false" @click="showCourseDlg"
                      >选择课程</el-link
                    >
                  </span>
                  <el-input v-model="courseName" disabled placeholder="请选择"></el-input>
                  <!--<el-input v-model="dataForm.courseCode" v-show="false"></el-input>-->
                </el-form-item>
                <el-dialog :modal="false" width="80%" :visible.sync="dialogTableVisibles">
                  <div style="height: 600px">
                    <offeringCoursedlist
                      ref="offeringCoursedlist"
                      @offeringcodeadd="offeringcodeadd"
                      @offeringcodelist="offeringcodelist"
                      @selectCodeClose="selectCodeClose"
                    >
                    </offeringCoursedlist>
                  </div>
                </el-dialog>
              </el-col>
              <!-- 所在城市 -->
              <el-col :span="8">
                <el-form-item :label="$t('res.site.city')" class="search-item">
                  <address-select
                    :level="2"
                    v-model="dataForm.regionIds"
                    placeholder="请选择"
                  >
                  </address-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('offering.offeringNo')" class="search-item">
                  <el-input
                    v-model="dataForm.offeringNo"
                    clearable
                    :placeholder="$t('course.plsin')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row class="margb10">
              <!-- 开始时间 -->
              <el-col :span="8">
                <el-form-item :label="$t('offering.startdate')" class="search-item">
                  <el-date-picker
                    style="width: 100%"
                    v-model="startdateRange"
                    type="daterange"
                    format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <!-- 结束时间  -->
                <el-form-item :label="$t('offering.enddate')" class="search-item">
                  <el-date-picker
                    style="width: 100%"
                    v-model="enddateRange"
                    type="daterange"
                    format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="查看本店报名排期" class="search-item">
                  <el-select v-model="dataForm.offeringadminYN">
                    <el-option
                      v-for="item in selofferingadminYN"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 高级搜索 只有两排 不显示--->
            <div v-show="isShow">
              <el-row class="btnAdvancedSearch"> </el-row>
            </div>
            <!-- 课程团队分类 course_team_catalog_id course.courseTeamCatalogId -->
            <el-row>
              <el-col :span="8"> </el-col>
            </el-row>
          </el-col>
          <el-col :span="6" v-if="false">
            <div @click="isShow = !isShow" class="toggle-btn">
              <span style="color: rgba(28, 105, 212, 100)">{{
                moreList ? "收起" : "高级搜索"
              }}</span>
              <img
                v-if="isShow"
                style="width: 8px; height: 4px; margin-left: 8px"
                src="../../../../assets/img/learning/Scheduling/search_icon_up@1x.png"
                alt=""
              />
              <img
                v-else
                style="width: 8px; height: 4px; margin-left: 8px"
                src="../../../../assets/img/learning/Scheduling/search_icon_down@1x.png"
                alt=""
              />
            </div>
            <!-- <div class="toggle-btn" @click="moreList = !moreList">
                     {{moreList ? '收起 上' : '高级搜索 下' }}
                  </div>  -->
            <!-- <el-row >
                <el-col :span="24"> -->

            <!-- <div class="show-or-hide-icon"
                      v-bind:class="{ 'el-icon-arrow-up': moreList,
                                              'el-icon-arrow-down': !moreList }"
                      >&nbsp;{{ moreList ? '收起' : '高级搜索' }}
                  </div> -->
            <!-- </el-col>
              </el-row> -->
          </el-col>
          <el-row class="search-btn">
            <el-col :span="24">
              <!-- 重置 -->
              <el-button class="el-back info-btn" type="info" @click="again"
                >{{ $t("reset") }}
              </el-button>
              <el-button class="primary-btn" type="primary" @click="getDataListMerge"
                >{{ $t("course.query") }}
              </el-button>
            </el-col>
          </el-row>
        </el-row>

        <!-- ---->
      </el-form>
      <!-- <el-row style="text-align: center; margin-bottom: 10px">
        <el-col :span="24">
          <div
            class="show-or-hide-icon"
            v-bind:class="{
              'el-icon-arrow-up': isShow,
              'el-icon-arrow-down': !isShow,
            }"
            @click="isShow = !isShow"
          >
            &nbsp;{{ isShow ? "收起" : "高级搜索" }}
          </div>
        </el-col>
      </el-row> -->
      <!--      <el-row style="text-align: center; margin-bottom: 10px;">-->
      <!--        <el-col :span="24">-->
      <!--          <div class="show-or-hide-icon">-->
      <!--          </div>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    </div>
    <el-dialog
      title="取消排期"
      :modal="true"
      :close-on-click-modal="false"
      @close="closeCancelDlg"
      :destroy-on-close="true"
      width="45%"
      :visible.sync="dialogofferingCancel"
    >
      <!-- :datalists="scope.row" -->
      <!-- <div style="height: 600px;"> -->
      <offeringCancel
        ref="offeringCancel"
        @closeCancelDlg="closeCancelDlg"
        :datalists="this.dateCancellist"
      >
      </offeringCancel>
      <!-- </div> -->
    </el-dialog>
    <el-dialog
      title="取消排期"
      :modal="true"
      :close-on-click-modal="false"
      @close="closeCancelview"
      :destroy-on-close="true"
      width="50%"
      :visible.sync="dialogofferingCancelview"
    >
      <!-- :datalists="scope.row" -->
      <!-- <div style="height: 600px;"> :datalists=this.dateCancellist-->
      <offeringCancelView
        ref="offeringCancelview"
        @closeCancelDlgview="closeCancelDlgview"
      >
      </offeringCancelView>
      <!-- </div> -->
    </el-dialog>
    <div style="padding-top: 0px">
      <div class="action">
        <div class="action-left">
          <!-- 新增 btnAdded -->
          <el-button
            type="primary"
            class="action-btn"
            v-if="$hasPermission('learning:base:offering:offeringEdit')"
            @click="changeRevise"
            >{{ $t("add") }}</el-button
          >
          <!-- 导出 btnExport -->
          <el-tooltip placement="top-start" effect="light">
            <div slot="content">{{ $t("couse.exportMsg") }}</div>
            <el-button
              style="padding: 8px 16px !important"
              type="primary"
              class="action-btn btnColorBlack"
              v-if="$hasPermission('learning:base:offering:offeringExport')"
              @click="exportHandle()"
            >
              <img
                style="margin-top: -2px; width: 14px; height: 14px"
                src="../../../../assets/img/learning/Scheduling/button_icon_export@1x.png"
                alt=""
              />
              {{ $t("export") }}
              <img
                style="margin-top: -2px; width: 14px; height: 14px"
                src="../../../../assets/img/learning/Scheduling/general_icon_question@1x.png"
                alt=""
              />
            </el-button>
          </el-tooltip>
          <!-- 下载排期模板 btnSchedulTemplateDownload  -->
          <el-button
            type="primary"
            class="action-btn"
            v-if="$hasPermission('learning:base:offering:SchedulTemplateDownload')"
            @click="onScheduleTemplateDownload()"
            >{{ $t("offering.downloadtemplate") }}</el-button
          >
          <!-- 批量导入 btnBulkUpload  @click="exportHandle()" -->
          <el-button
            type="primary"
            class="action-btn"
            v-if="$hasPermission('learning:base:offering:offeringBatchImport')"
            >{{ $t("offering.batchImport") }}</el-button
          >
          <!-- 结果报告下载 -->
          <el-button
            class="action-btn"
            type="primary"
            v-if="$hasPermission('learning:base:offering:offeringImportReport')"
            >{{ $t("offering.report") }}</el-button
          >
          <!-- 发布 btnBatchRelease  @click="toggleSelection(inputvalues)" @click="exportHandle()" -->
          <el-button
            class="action-btn"
            type="primary"
            v-if="$hasPermission('learning:base:offering:offeringBatchRelease')"
            @click="onBatchRelease()"
            >{{ $t("offering.Release") }}</el-button
          >
          <!-- 批量上传 校验 -->
          <el-button
            class="action-btn"
            type="primary"
            @click="onGroupUpload()"
            v-if="$hasPermission('learning:base:offering:multiGroupUpload')"
            >{{ $t("offering.mutliUpdate") }}</el-button
          >
        </div>
        <div class="action-right">
          <el-button
            class="btnBatchDeletion btnBatchDeletion:hover btnBatchDeletion:active btnBatchDeletion:focus"
            type="danger"
            v-if="$hasPermission('learning:base:offering:offeringBatchDelete')"
            @click="onDelete()"
            >{{ $t("offering.batchdeletion") }}</el-button
          >
        </div>
      </div>
      <!-- 表头动态展示 -->

      <el-table
        v-loading="dataListLoading"
        ref="multipleTable"
        :data="dataList"
        border
        :row-style="{ height: 48 + 'px' }"
        :cell-style="{ padding: 0 + 'px' }"
        @selection-change="dataListSelectionChangeHandle"
      >
        <!--                style="height:527px; width: 100%;overflow:initial;">-->
        <!--序号-->
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          :label="$t('offering.no')"
          type="index"
          width="50"
          align="center"
          fixed
        >
          <template slot-scope="scope"
            ><span>{{ (page - 1) * limit + scope.$index + 1 }}</span></template
          >
        </el-table-column>
        <!-- 课程中文名称，场地，报名人数，开始时间，结束时间，培训师，排期名称，排期编号，课程代码，排期状态。*****-->
        <!--课程中文名称-->
        <el-table-column
          prop="courseNameCn"
          :label="$t('couse.coursenamecn')"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          width="180"
          fixed
        >
          <template slot-scope="sc" style="width: 130px; float: left">
            <div>
              <el-dropdown-item style="color: #409eff" @click.native="showViewpc(sc)">{{
                sc.row.courseNameCn
              }}</el-dropdown-item>
            </div>
            <!-- <span @click.native="showView(sc)">{{sc.row.offeringNo}}</span> -->
          </template>
        </el-table-column>
        <!-- 场地 prop="courseStatus" :formatter="coursestatusformat" -->
        <el-table-column
          prop="siteName"
          :label="$t('offering.local')"
          header-align="center"
          align="left"
          width="160"
          :show-overflow-tooltip="true"
          fixed
        ></el-table-column>
        <!-- 报名人数 -->
        <el-table-column
          prop="registNumber"
          :label="$t('offering.countuser')"
          header-align="center"
          width="100"
          :formatter="registformat"
          :show-overflow-tooltip="true"
          align="center"
          fixed
        ></el-table-column>
        <!-- 开始时间 -->
        <el-table-column
          prop="startdate"
          :label="$t('offering.startdate')"
          header-align="center"
          align="center"
          width="145"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 结束时间 -->
        <el-table-column
          prop="enddate"
          :label="$t('offering.enddate')"
          header-align="center"
          align="center"
          width="145"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!-- 培训师 prop="courseBrand"  :formatter="BrandFormat" -->
        <el-table-column
          :label="$t('offering.trainer')"
          prop="trainerName"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          width="80"
        ></el-table-column>
        <!-- 排期名称 -->
        <el-table-column
          prop="offeringName"
          :label="$t('offering.offringname')"
          header-align="center"
          align="left"
          width="100"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <!--offering编号 -->
        <el-table-column
          prop="offeringNo"
          :label="$t('offering.offeringNo')"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
          :width="130"
        >
          <!-- <template slot-scope="sc"
                    style="width: 130px; float: left;">

            <div>
              <el-dropdown-item style="color: #409eff;"
                                @click.native="showView(sc)">{{ sc.row.offeringNo }}</el-dropdown-item>
            </div>
          </template> -->
          <!-- <span @click.native="showView(sc)">{{sc.row.offeringNo}}</span> -->
        </el-table-column>
        <!-- 课程代码  -->
        <el-table-column
          prop="courseCode"
          :label="$t('couse.coursecode')"
          header-align="center"
          align="center"
          width="110"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <!--课程英文名称-->
        <!-- <el-table-column prop="courseNameEn"
                         :label="$t('couse.coursenameen')"
                         header-align="center"
                         align="left"
                         :show-overflow-tooltip="true"
                         width="180"></el-table-column> -->

        <!-- 排期状态 -->
        <el-table-column
          prop="offeringStatus"
          :label="$t('offering.offringstatus')"
          header-align="center"
          :formatter="demandformat"
          :show-overflow-tooltip="true"
          align="center"
        ></el-table-column>

        <!--创建人  :formatter="createuserFormat" -->
        <!--       <el-table-column-->
        <!--                         label=""-->
        <!--                         header-align="left"-->
        <!--                         align="left"-->
        <!--                         :show-overflow-tooltip="true"-->
        <!--                         ></el-table-column> -->

        <!--操作 -->
        <el-table-column
          :label="$t('offering.operation')"
          fixed="right"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <div style="">
              <!-- <span class="el-dropdown-link"
                    @click="showView(scope)">{{ $t('view') }}</span> -->
              <!-- <div class="pkg-vertical-divider"></div> -->
              <el-dropdown trigger="click" placement="bottom">
                <span class="el-dropdown-link">
                  {{ $t("offering.more") }}
                  <img
                    style="
                      vertical-align: middle;
                      width: 8px;
                      height: 4px;
                      margin-left: 8px;
                    "
                    src="../../../../assets/img/learning/Scheduling/search_icon_down@1x.png"
                    alt=""
                  />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <!-- 编辑/复制/取消/删除/发布/分配/查看人员名单 -->

                  <!--编辑 && scope.row.startdate <= new Date() TODO:  -->
                  <el-dropdown-item
                    v-if="checkEditRole(scope.row)"
                    @click.native="changeBuild(scope.row)"
                  >
                    {{ $t("offering.edit") }}
                  </el-dropdown-item>
                  <!--复制 -->
                  <el-dropdown-item
                    v-if="checkCopyRole(scope.row)"
                    @click.native="gotoView('copy', scope.row)"
                  >
                    {{ $t("offering.copy") }}
                  </el-dropdown-item>
                  <!-- 取消 -->
                  <el-dropdown-item
                    v-if="checkCancelRole(scope.row)"
                    @click.native="onCancel(scope.row)"
                  >
                    {{ $t("offering.cancel") }}
                  </el-dropdown-item>
                  <!-- 查看取消 -->
                  <el-dropdown-item
                    v-if="checkCancelviewRole(scope.row)"
                    @click.native="onCancelview(scope.row)"
                  >
                    {{ $t("offering.cancelview") }}
                  </el-dropdown-item>
                  <!--删除 -->
                  <el-dropdown-item
                    v-if="checkDeleteRole(scope.row)"
                    @click.native="gotoView('delete', scope.row)"
                  >
                    {{ $t("offering.listDelete") }}
                  </el-dropdown-item>
                  <!-- 发布 -->
                  <el-dropdown-item
                    v-if="checkReleaseRole(scope.row)"
                    @click.native="gotoView('release', scope.row)"
                  >
                    {{ $t("offering.Release") }}
                  </el-dropdown-item>
                  <!-- 人员名单 -->
                  <el-dropdown-item
                    v-if="checkPersonnelListRole(scope.row)"
                    @click.native="showPeopleList(scope.row)"
                  >
                    {{ $t("offering.showplist") }}
                  </el-dropdown-item>
                  <!-- 分配TWO -->
                  <el-dropdown-item
                    v-if="checkAssignUserRole(scope.row)"
                    @click.native="assignUser(scope.row)"
                  >
                    {{ $t("分配") }}
                  </el-dropdown-item>
                  <!-- 人员名单  经销商 -->
                  <el-dropdown-item
                    v-if="checkSeltctPersonnelListRole(scope.row)"
                    @click.native="showUserView(scope)"
                  >
                    {{ $t("人员名单(替换/撤销)") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>

    <!-- 弹窗, 新增 / 编辑 -->
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
    <subordinate-site
      ref="suborSiteRef"
      :isSingleElection="false"
      v-bind:selectTable="selectTable"
      :dialogVisible="isShowSuboSite"
      v-on:closeSuboSiteDlg="closeSuboSiteDlg"
      v-on:bringBack="bringBack"
    >
    </subordinate-site>
    <course-multiple
      ref="refCourseMultiple"
      :isSingleElection="false"
      v-bind:selectCourseTable="selectCourseTable"
      :dialogVisible="isShowCourse"
      v-on:closeCourseDlg="closeCourseDlg"
      v-on:resetCourseData="resetCourseData"
      v-on:courseSelectBack="courseSelectBack"
    >
    </course-multiple>
    <!-- 批量更新 -->
    <groupUploadModal
      v-if="groupUpdateVisible"
      @closeCancelDlg="closeCancelDlgOfferingBatchUp2"
      url="/learning/courseinfo/import"
      shuttering="/learning/courseinfo/import_mould"
      :name="$t('couse.couseImporttemplate')"
    ></groupUploadModal>
    <!-- 弹窗, 新增 / 修改 -->
    <assign-user
      v-if="assignUserVisible"
      ref="assignUser"
      @refreshDataList="getDataList"
    ></assign-user>
    <!--标签查询条件-->
    <el-dialog
      title="选择标签"
      :visible="isQueryShowLable"
      width="70%"
      :before-close="showQueryLableClose"
    >
      <el-form label-position="top" label-width="150px" :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName" style="width: 100% !important">
                <tag
                  :checkedList="courseTreeList"
                  :overLabelShow="true"
                  :closeShow="true"
                  :brandCode="bussinessTypeChecked"
                  @changeCheckedList="changeCheckedList"
                  ref="tagTree"
                  @fatherMethod="fatherMethod"
                ></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div>
        <el-button type="primary" @click="onOkLable">{{
          $t("res.rela.determine")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import Vue from 'vue'
import catalogtree from "../common/catalogtree";
import assignUser from "../course/registe/assignuser";
import courseTeamCatalogtree from "../common/courseTeamCatalogtree";
import mixinViewModule from "@/mixins/view-module";
import ToggleDiv from "@/components/toggle-div";
import offeringCoursedlist from "./offeringcommon/offeringCoursedlist";
import offeringcitytree from "../common/offeringcitytree";
import offeringlocaltree from "../common/offeringlocaltree";
import siteSelect from "@/components/rm/subordinate-site/index";
import RegionTree from "@/components/region-tree/index";
import courseSelect from "@/components/learning/course-multiple/indexDealerAdmin";
import offeringCancel from "./offeringcommon/offeringCancel";
import offeringCancelView from "./offeringcommon/offeringCancelView";
import AddressSelect from "@/components/address-select";
import ClassTree from "../common/class-tree/index";
import Tag from "@/components/learning/label-select/index";
import showpccourse from "./offeringcommon/showpcCourse/show";
import groupUploadModal from "./groupUploadModal";
export default {
  mixins: [mixinViewModule],
  data() {
    let _this = this;
    return {
      tagInputShow: true,
      vehicleLabelShowFlg: true,
      courseTreeList: [],
      isShowLable: false,
      bussinessTypeChecked: null,
      isQueryShowLable: false,
      commLabelProps: {
        children: "children",
        label: "labelNameCn",
      },
      queryclassroomUrl: "/learning/courseinfo/courseLabelTree",
      props: {
        inputvalues: String,
      },
      // 课程分类树
      defaultPropsz: {
        children: "children",
        label: "catalogNameCn",
        id: "catalogId",
      },
      showVehicleClassList: [],
      showValue: "",
      isShowSuboSite: false,
      queryTreeUrl: "/learning/coursecatalog/list",
      // 课程团队树
      defaultPropsVisible: {
        children: "children",
        label: "catalogNameCn",
        id: "catalogId",
      },
      showVehicleClassListVisible: [],
      showValueVisible: "",
      queryTreeUrlVisible: "/learning/coursecatalog/list",
      mixinViewModuleOptions: {
        getDataListURL: "/learning/base/offeringinfo/page",
        getDataListIsPage: true,
        deleteURL: "/learning/base/offeringinfo/delete",
        batchDeleteURL: "/learning/base/offeringinfo/batchDelete",
        releaseUrl: "/learning/base/offeringinfo/release",
        batchReleaseUrl: "/learning/base/offeringinfo/batchRelease",
        cancelUrl: "/learning/base/offeringinfo/cancel",
      },
      scheduleTemplateURL: "/learning/base/offeringinfo/onScheduleTemplateDownload",
      offeringStatus: _this.enums["offeringstatus"],
      datalist: [],
      dateCancellist: {},
      dialogTableVisibles: false,
      dialogofferingCancel: false,
      dialogofferingCancelview: false,
      assignUserVisible: false,
      dataForm: {
        offeringNo: "",
        offeringName: "",
        offringstatus: "20",
        catalogId: "", // 课程分类
        courseTeamCatalogFirst: "",
        courseTeamCatalogSecond: "", // 课程团队分类
        courseid: "",
        // coursename: '',
        regionIds: [],
        cityClassList: [],
        courseCode: "",
        courselabel: "", // 课程标签
        startTime: "",
        endTime: "",
        city: "",
        createUserNameEn: "",
        offeringadminYN: "20",
      },
      selofferingadminYN: [
        {
          value: "10",
          label: "是",
        },
        {
          value: "20",
          label: "否",
        },
      ],
      selectTable: [],
      selectCourseTable: [],
      courseName: "",
      select1: _this.enums["catalogidList1"],
      allteamcatalog: _this.enums["catalogidList2"],
      // select1c: [
      //   { value: '10', label: 'BBS-50' },
      //   { value: '20', label: 'BBS-51' },
      //   { value: '30', label: 'BBS-52' },
      //   { value: '40', label: 'BBS-53' },
      //   { value: '50', label: 'H5' },
      //   { value: '60', label: 'Non TA' }],
      loading: false,
      select2: [],
      // allteamcatalog1: [
      //   { pro: '10', label: '50' },
      //   { pro: '20', label: 'BP' },
      //   { pro: '20', label: 'ME' },
      //   { pro: '20', label: 'Others' },
      //   { pro: '30', label: 'MA' },
      //   { pro: '30', label: 'S&M' },
      //   { pro: '30', label: 'Others' },
      //   { pro: '40', label: 'Parts' },
      //   { pro: '40', label: 'Service' },
      //   { pro: '40', label: 'Others' },
      //   { pro: '40', label: 'CCM' },
      //   { pro: '50', label: 'H5' },
      //   { pro: '60', label: 'CRM Coaching' },
      //   { pro: '60', label: 'AS Coaching' },
      //   { pro: '60', label: 'SF' }

      // ],
      couresList: [], // 课程分类使用
      couresListVisible: false, // 课程分类使用
      catalogidList: [], // 课程团队分类用
      catalogidListVisible: false, // 课程团队分类用
      // 展示更多
      showBrand: true,
      userTableData: [],
      // 等待转圈
      dataListLoading: false,
      isShow: false,
      checkAll: false,
      // 设置按钮pop状态
      visible: false,
      startdateRange: [],
      enddateRange: [],
      offeringBlendRead: "0",
      queryCityTreeUrl: "/learning/otherinfo/list", // '/rm/commRegion/list',
      // 城市分类
      citydefaultProps: {
        children: "childrenRegionList",
        label: "regionNameCn",
      },
      isShowCourse: false,
      groupUpdateVisible: false,
    };
  },
  components: {
    Tag,
    ToggleDiv,
    catalogtree,
    assignUser,
    courseTeamCatalogtree,
    offeringCoursedlist,
    offeringcitytree,
    offeringlocaltree,
    "subordinate-site": siteSelect,
    "region-tree": RegionTree,
    "course-multiple": courseSelect,
    offeringCancel,
    offeringCancelView,
    AddressSelect,
    "class-tree": ClassTree,
    showpccourse,
    groupUploadModal,
  },
  created() {
    if (
      this.$route.query.catalogId !== "" &&
      this.$route.query.catalogId !== undefined &&
      this.$route.query.catalogId !== null
    ) {
      this.dataForm.catalogId = this.$route.query.catalogId;
    }
  },
  methods: {
    showViewpc(scope) {
      this.$router.push({
        // name: 'learning-offering-offeringcommon-showpcCourse-show',
        name: "learning-offering-show",
        query: { courseCode: scope.row.courseCode },
      });
    },
    onOkLable() {
      console.info("132564");
      console.info(this.courseTreeList);
      console.info("56465879");
      let args = this.courseTreeList;
      if (args && args !== "" && args.length > 0) {
        let trainerLabelinfo = [];
        let trainerLabelinfoName = [];
        args.forEach(function (item) {
          trainerLabelinfo.push(item.labelId);
          trainerLabelinfoName.push(item.labelName);
        });
        this.dataForm.courseLabel = trainerLabelinfo;
        this.dataForm.labelTypeName = trainerLabelinfoName.join(",");
        console.info(this.dataForm.courseLabel);
        console.info(this.dataForm.labelTypeName);
        this.tagInputShow = false;
      } else {
        this.dataForm.courseLabel = [];
        this.dataForm.labelTypeName = "";
        this.tagInputShow = true;
      }
      this.isQueryShowLable = false;
    },
    showLableClose() {
      this.isShowLable = false;
    },
    //  列表 课程标签查询
    checkLable(row) {
      this.isShowLable = true;

      console.info("hgjghj");
      console.info(row);
      console.info(row.courseLabel);
      console.info("qwerbcvbcbqwer");
      this.checkList = [];
      let checkListtemp = row.courseLabel.trim().split(",");
      checkListtemp.forEach((o) => {
        if (o !== "" && o !== null) {
          let row = {};
          row.labelName = o;
          this.checkList.push(row);
        }
      });
      this.dataForm.LableCheckShow = this.checkList;
      console.log(this.checkList);
    },
    trainerLabelLeave() {
      this.vehicleLabelShowFlg = false;
    },
    // 课程标签 点击x 清空
    trainerLabelName() {
      this.dataForm.courseLabel = [];
      this.dataForm.labelTypeName = "";
      this.courseTreeList = [];
      this.vehicleLabelShowFlg = false;

      try {
        this.$refs.tagTree.isReset();
      } catch (e) {
        console.log(e);
      }
      this.tagInputShow = true;
    },
    // 重新勾选业务标签
    fatherMethodShow() {
      this.checkList = [];
      let checkListtemp = this.dataForm.LableCheckShow;
      checkListtemp.forEach((o) => {
        if (o !== "" && o !== null) {
          let row = {};
          row.labelName = o.labelName;
          this.checkList.push(row);
        }
      });
    },
    // 重新勾选业务标签
    fatherMethod() {
      console.log("查看 fatherMethod");
      this.courseTreeList = [];
      // 已选择的标签
      this.courseTreeList = this.dataForm.commLabelVoList
        ? this.dataForm.commLabelVoList
        : [];
      // this.courseTreeList = this.checkList ? this.checkList : []
      // 特殊情况，自己国际化
      this.courseTreeList.forEach((o) => {
        o.labelName = o.labelNameCn;
      });
    },
    changeCheckedList(array) {
      this.courseTreeList = array;
    },
    showQueryLableClose() {
      this.isQueryShowLable = false;
    },
    showLable() {
      this.isQueryShowLable = true;
    },
    getClassroomList(args) {
      let courseLabel = [];
      args.forEach(function (item) {
        courseLabel.push(item.id);
      });
      this.dataForm.courseLabel = courseLabel.join(",");
    },
    // 关闭事件
    closeCancel() {
      // this.xxx = ''
    },
    // 关闭事件
    closeCancelview() {
      // this.xxx = ''
    },
    closeSuboSiteDlg() {
      this.isShowSuboSite = false;
    },
    showSuboSiteDlg() {
      this.isShowCourse = false;
      this.isShowSuboSite = false;
      this.$refs.suborSiteRef.initSuborSite();
      this.isShowSuboSite = true;
    },
    closeCourseDlg() {
      console.log("closeCOurseDlg");
      console.log(this.isShowCourse);
      this.isShowCourse = false;
      console.log(this.isShowCourse);
    },
    showCourseDlg() {
      this.isShowCourse = false;
      this.$refs.refCourseMultiple.initSuborSite();
      this.isShowCourse = true;
    },
    resetCourseData() {
      this.selectCourseTable = [];
      this.courseName = "";
    },
    courseSelectBack(selection) {
      console.log(selection);
      console.log(selection);
      let ids = [];
      let names = [];
      let codes = [];
      selection.forEach((item) => {
        ids.push(item.courseId);
        names.push(item.courseNameCn);
        codes.push(item.courseCode);
      });
      this.courseName = names.join("/");
      this.dataForm.courseCode = codes.join(",");
      this.dataForm.courseid = ids.join(",");
      this.selectCourseTable = selection;
      this.isShowCourse = false;
      this.closeCourseDlg();
    },
    bringBack(selection) {
      console.log(selection);
      let siteNames = [];
      let siteIds = [];
      let siteClassNameCns = [];
      let cityNames = [];
      let cityIds = [];
      let siteCodes = [];
      selection.forEach((item) => {
        siteNames.push(item.siteCnName);
        siteIds.push(item.id);
        siteClassNameCns.push(item.siteClassCnName);
        cityNames.push(item.cityName);
        cityIds.push(item.cityId);
        siteCodes.push(item.siteNo);
      });
      console.log(this.dataForm);
      this.dataForm.siteId = siteIds.join(",");
      // this.dataForm.cityId = cityIds.join(',')
      // this.dataForm.cityName = cityNames.join(',')
      this.dataForm.location = siteNames.join("/");
      // this.dataForm.siteName = siteNames.join(',')
      // this.dataForm.siteCode = siteCodes.join(',')
      // this.dataForm.siteClassNameCn = siteClassNameCns.join(',')
      this.isShowSuboSite = false;
      this.selectTable = selection;
      this.closeSuboSiteDlg();
    },
    offeringlistk: function () {
      this.courseName = "";
      this.dataForm.courseid = "";
      this.dataForm.courseCode = "";
    },
    dataListSelectionChangeHandle(val) {
      this.datalists = [];

      val.forEach((row) => {
        this.datalists += row.offeringId + ",";
      });
      this.datalist = this.datalists;
    },
    // 分配
    assignUser(row) {
      console.log("assignUser start");
      console.info("RRRRRRRR--->>", row);
      this.assignUserVisible = true;
      /* eslint-disable */
      // debugger
      let allDataList = this.dataList;
      this.$nextTick(() => {
        /* this.$refs.assignUser.offeringId = row.offeringId
        // 赋值初始化
        this.$refs.assignUser.init() */
        // 跨组件传值
        this.$refs.assignUser.dataofferinginfo.offeringId = row.offeringId;
        this.$refs.assignUser.dataofferinginfo.offeringNo = row.offeringNo;
        // this.$refs.assignUser.dataofferinginfo.courseId = row.courseId
        this.$refs.assignUser.dataofferinginfo.courseCode = row.courseCode;
        this.$refs.assignUser.dataofferinginfo.courseNameCn = row.courseNameCn;
        this.$refs.assignUser.dataofferinginfo.trainerName = row.trainerName;
        this.$refs.assignUser.dataofferinginfo.offeringName = row.offeringName;
        this.$refs.assignUser.dataofferinginfo.site = row.siteName;
        // this.$refs.assignUser.dataofferinginfo.siteName = row.site
        this.$refs.assignUser.dataofferinginfo.startdate = row.startdate;
        this.$refs.assignUser.dataofferinginfo.enddate = row.enddate;
        this.$refs.assignUser.dataofferinginfo.coursePrice = row.coursePrice;

        this.$refs.assignUser.dataForm.offeringId = row.offeringId;

        this.$refs.assignUser.applyNumber = row.applyNumber;
        this.$refs.assignUser.maxNumber = row.maxNumber;

        this.$refs.assignUser.parentData = allDataList;

        this.$refs.assignUser.init();
        this.$refs.assignUser.queryDealerBalance();
        // this.$refs.assignUser.getDataListMerge(allDataList)
      });
      this.$router.push({
        query: { offeringId: row.offeringId },
        userId: row.userId,
        registeId: row.registeId,
      });
    },
    // 调用人员分配界面(报名人数大于0)
    showUserView(scope) {
      /* eslint-disable */
      // debugger
      this.$router.push({
        name: "learning-course-registe-registeuserlist",
        query: {
          registeId: scope.row.registeId,
          offeringId: scope.row.offeringId,
          offeringNo: scope.row.offeringNo,
          courseId: scope.row.courseId,
          courseCode: scope.row.courseCode,
          courseNameCn: scope.row.courseNameCn,
          trainerName: scope.row.trainerName,
          offeringName: scope.row.offeringName,
          site: scope.row.siteName,
          siteName: scope.row.siteName,
          startdate: scope.row.startdate,
          enddate: scope.row.enddate,
        },
      });
      this.$eventHub.$emit("USER_QUERY_XPY77", "");
      // this.$eventHub.$emit('showViewUser', '')
      // if (scope.row.applyNumber > 0) {
      // }
    },
    // 选择课程时调用
    offeringcodelist: function (data) {
      console.log(data);
      let ids = [];
      let names = [];
      let codes = [];
      data.forEach((item) => {
        ids.push(item.courseid);
        names.push(item.courseName);
        codes.push(item.courseCode);
      });
      this.courseName = names.join(",");
      this.dataForm.courseCode = codes.join(",");
      this.dataForm.courseid = ids.join(",");
    },
    /* 字符串去重 */
    quchongstr(str) {
      var a = str.split(",");
      a.sort();
      for (var i = a.length - 1; i > 0; i--) {
        if (a[i] === a[i - 1]) {
          a.splice(i, 1);
        }
      }
      return a.join(",");
    },
    quchong(arr) {
      var result = [];
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].couresName]) {
          result.push(arr[i]);
          obj[arr[i].couresName] = true;
        }
      }
      return result;
    },
    // 课程分类调用树
    cateloglist: function (data) {
      let catalogId = "";
      let catalogNameCn = "";
      data[0].data.forEach((rows) => {
        catalogId = catalogId + rows.catalogId + ",";
        catalogNameCn = catalogNameCn + rows.catalogNameCn + ",";
      });
      // this.$message(catalogId)
      this.dataForm.catalogId = catalogId;
    },
    // 课程团队分类调用树
    catalogidListVisiblelist: function (data) {
      let catalogId = "";
      let catalogNameCn = "";
      data[0].data.forEach((rows) => {
        catalogId = catalogId + rows.catalogId + ",";
        catalogNameCn = catalogNameCn + rows.catalogNameCn + ",";
      });
      // this.$message(catalogId)
      this.dataForm.courseTeamCatalogId = catalogId;
    },
    // 新增
    changeRevise() {
      // this.$router.push({ path: 'course-course' })
      this.$router.push({
        name: "learning-offering-offeringEdit",
      });
      this.$eventHub.$emit("offbaseAdd", "");
    },
    // 修改
    changeBuild(row) {
      this.$router.push({
        name: "learning-offering-offeringEdit",
        query: { offeringId: row.offeringId },
      });
      this.$eventHub.$emit("offbaseShow", "");
    },
    // 查看
    showView(scope) {
      this.$router.push({
        name: "learning-offering-offeringShow",
        query: { offeringId: scope.row.offeringId },
      });
      this.$eventHub.$emit("showViewOffering", "");
    },
    // 查询
    getDataListMerge() {
      this.page = 1;
      let d = new Date();
      // 由于日期区间是2个国际标准的时间字符串显示进行了下面的判断和转换
      if (this.startdateRange === null || this.startdateRange.length === 0) {
        this.dataForm.startTime = "";
      } else {
        // 区间的开始日期默认00:00:00
        d = new Date(this.startdateRange[0]);
        let start1 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 00:00:00";
        // 区间的结束日期默认23:59:59
        d = new Date(this.startdateRange[1]);
        let start2 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 23:59:59";
        this.dataForm.startTime = start1 + "," + start2;
      }
      if (this.enddateRange === null || this.enddateRange.length === 0) {
        this.dataForm.endTime = "";
      } else {
        d = new Date(this.enddateRange[0]);
        let end1 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 00:00:00";
        d = new Date(this.enddateRange[1]);
        let end2 =
          d.getFullYear() +
          "-" +
          this.checkTime(d.getMonth() + 1) +
          "-" +
          this.checkTime(d.getDate()) +
          " 23:59:59";
        this.dataForm.endTime = end1 + "," + end2;
      }
      this.dataForm.cityClassList = this.dataForm.regionIds;
      this.getDataList();
    },
    // 重置
    again() {
      this.trainerLabelName();
      this.selectTable = [];
      this.selectCourseTable = [];
      this.dataForm = {
        offeringNo: "",
        offeringName: "",
        offringstatus: "20",
        catalogId: "", // 课程分类
        courseTeamCatalogFirst: "",
        courseTeamCatalogSecond: "", // 课程团队分类
        courseid: [],
        // coursename: '',
        regionIds: [],
        courseCode: [],
        courselabel: "", // 课程标签
        startTime: "",
        endTime: "",
        offeringadminYN: "20",
      };
      this.courseName = "";
      this.startdateRange = [];
      this.enddateRange = [];
      // this.select1 = [
      //   { value: '10', label: 'BBS-50' },
      //   { value: '20', label: 'BBS-51' },
      //   { value: '30', label: 'BBS-52' },
      //   { value: '40', label: 'BBS-53' },
      //   { value: '50', label: 'H5' },
      //   { value: '60', label: 'Non TA' }]
      this.loading = false;
      this.select2 = [];
      // this.allteamcatalog1 = [
      //   { pro: '10', label: '50' },
      //   { pro: '20', label: 'BP' },
      //   { pro: '20', label: 'ME' },
      //   { pro: '20', label: 'Others' },
      //   { pro: '30', label: 'MA' },
      //   { pro: '30', label: 'S&M' },
      //   { pro: '30', label: 'Others' },
      //   { pro: '40', label: 'Parts' }, { pro: '40', label: 'Service' }, { pro: '40', label: 'Others' }, { pro: '40', label: 'CCM' },
      //   { pro: '50', label: 'H5' },
      //   { pro: '60', label: 'CRM Coaching' }, { pro: '60', label: 'AS Coaching' }, { pro: '60', label: 'SF' }
      // ]
      try {
        this.$refs.offeringCoursedlist.toggleSelection();
      } catch (e) {}
      // this.select1 = []
      // this.select2 = []
      this.getDataListMerge();
    },
    // 操作列下拉选项  distribution
    gotoView(type, id) {
      if (type === "view") {
        this.$router.push({
          name: "coure-position",
          query: {
            orgId: id,
          },
        });
      } else if (type === "delete") {
        this.deleteCourse(id);
      } else if (type === "release") {
        this.onRelease(id);
      } else if (type === "cancel") {
        this.onCancel(id);
      } else if (type === "copy") {
        this.copyOffering(id);
      }
    },
    checkTime(i) {
      // 这是时间格式化时一位数补充0的处理
      if (i < 10) {
        i = "0" + i;
      }
      return i;
    },
    // 复制排期
    copyOffering(row) {
      this.$request
        .put(`/learning/base/offeringinfo/copyOffering`, row)
        .then((res, total, code, data) => {
          // 复制后跳转编辑页面
          this.$router.push({
            path: "learning-offering-offeringEdit",
            query: { offeringId: data.data.offeringId },
          });
          this.$eventHub.$emit("offbaseShow", "");
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // 删除
    deleteCourse(row) {
      this.$confirm(
        this.$t("prompt.info", { handle: this.$t("delete") }),
        this.$t("prompt.title"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        }
      )
        .then(() => {
          this.$request
            .post(this.mixinViewModuleOptions.deleteURL, {
              offeringId: row.offeringId,
            })
            .then((res, total, code, data) => {
              console.log(data);
              if (data.code === 13000000) {
                this.$message({
                  message: this.$t("offering.deletetips"),
                  type: "info",
                  duration: 5000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
              } else {
                this.$message({
                  message: this.$t("prompt.success"),
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
                this.getDataListMerge();
              }
            })
            .catch((err) => {
              console.log(err)
            });
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // 发布
    onRelease(row) {
      this.$confirm(
        this.$t("prompt.info", { handle: this.$t("offering.Release") }),
        this.$t("prompt.title"),
        {
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
        }
      )
        .then(() => {
          this.$request
            .put(this.mixinViewModuleOptions.releaseUrl, {
              offeringId: row.offeringId,
            })
            .then((res, total, code, data) => {
              console.log(data);
              if (data.code === 13000000) {
                let msg = "";
                for (var i = 0; i < data.data.length; i++) {
                  msg = msg + data.data[i];
                }
                this.$message({
                  message: msg,
                  type: "info",
                  duration: 5000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
              } else {
                this.$message({
                  message: this.$t("prompt.success"),
                  type: "success",
                  duration: 1000,
                  onClose: () => {
                    console.log('onClose')
                  },
                });
                this.getDataListMerge();
              }
            })
            .catch((err) => {
              console.log(err)
            });
        })
        .catch((err) => {
          console.log(err)
        });
    },
    // 取消
    onCancel(row) {
      this.dialogofferingCancel = true;
      this.dateCancellist = row;
      this.$nextTick(() => {
        this.$refs.offeringCancel.getDealerBeforeGetInfo(row);
      });
    },
    // 查看取消
    onCancelview(row) {
      this.dialogofferingCancelview = true;
      this.dateCancellist = row;
      this.$nextTick(() => {
        // eslint-disable-next-line no-unused-expressions
        this.$refs.offeringCancelview.getDealerBeforeGetInfo(row);
      });
    },
    onBatchRelease() {
      let checkAll = "";
      var chexcksss = this.$refs.multipleTable.selection; // 得到选中的值
      chexcksss.forEach((row) => {
        checkAll = checkAll + "," + row.offeringId;
      });
      if (checkAll.length > 0) {
        this.$confirm(
          this.$t("prompt.info", { handle: this.$t("offering.Release") }),
          this.$t("prompt.title"),
          {
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
          }
        )
          .then(() => {
            this.$request
              .post(this.mixinViewModuleOptions.batchReleaseUrl, {
                offeringNo: checkAll,
              })
              .then((res, total, code, data) => {
                console.log(data);
                if (data.code === 13000000) {
                  let msg = "";
                  for (var i = 0; i < data.data.length; i++) {
                    msg = msg + data.data[i] + "<br/>";
                  }
                  this.$message({
                    dangerouslyUseHTMLString: true,
                    message: msg,
                    type: "info",
                    duration: 5000,
                    onClose: () => {
                      console.log('onClose')
                    },
                  });
                } else {
                  this.$message({
                    message: this.$t("prompt.success"),
                    type: "info",
                    duration: 1000,
                    onClose: () => {
                      console.log('onClose')
                    },
                  });
                  this.getDataListMerge();
                }
              })
              .catch((err) => {
                console.log(err)
              });
          })
          .catch((err) => {
            console.log(err)
          });
      } else {
        this.$message({
          message: this.$t("offering.checkListNull"),
          type: "info",
          duration: 5000,
        });
      }
    },
    onDelete() {
      let checkAll = "";
      var chexcksss = this.$refs.multipleTable.selection;
      chexcksss.forEach((row) => {
        checkAll = checkAll + "," + row.offeringId;
      });
      if (checkAll.length > 0) {
        this.$confirm(
          this.$t("prompt.info", { handle: this.$t("delete") }),
          this.$t("prompt.title"),
          {
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
          }
        )
          .then(() => {
            this.$request
              .post(this.mixinViewModuleOptions.batchDeleteURL, {
                offeringNo: checkAll,
              })
              .then((res, total, code, data) => {
                if (data.code === 13000000) {
                  let msg = "";
                  for (var i = 0; i < data.data.length; i++) {
                    msg = msg + data.data[i];
                  }
                  this.$message({
                    message: msg,
                    type: "info",
                    duration: 5000,
                    onClose: () => {
                      console.log('onClose')
                    },
                  });
                } else {
                  this.$message({
                    message: this.$t("prompt.success"),
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      console.log('onClose')
                    },
                  });
                  this.getDataListMerge();
                }
              })
              .catch((err) => {
                console.log(err)
              });
          })
          .catch((err) => {
            console.log(err)
          });
      } else {
        this.$message({
          message: this.$t("offering.checkListNull"),
          type: "info",
          duration: 5000,
        });
      }
    },
    toggle(val) {
      this.isShow = val;
    },
    // 导出
    exportHandle() {
      let selection = this.$refs.multipleTable.selection;
      let checkSel = [];
      for (let i = 0; i < selection.length; i++) {
        checkSel.push(selection[i].offeringId);
      }
      console.log("exportHandle");
      // download 参数 url, params, 报表名
      this.$request.downloadLearning(
        "/learning/base/offeringinfo/export",
        this.$t("offering.offeringExport"),
        {
          ...this.dataForm,
          page: this.page,
          limit: this.limit,
          offeringCheckList: checkSel,
        }
      );
    },
    onScheduleTemplateDownload() {
      this.$request.download(this.scheduleTemplateURL, "排期模板");
    },
    // 新增时add
    offeringcodeadd: function (data) {
      this.dataForm.courseCode = data.courseCode;
      this.dataForm.courseid = data.courseid;
      this.dialogTableVisibles = false;
    },
    courseDaysformat(row, column, cellValue) {
      return cellValue.toFixed(2);
    },
    selectCodeClose() {
      this.dialogTableVisibles = false;
    },
    closeCancelDlg() {
      this.dialogofferingCancel = false;
      this.getDataList();
    },
    closeCancelDlgview() {
      this.dialogofferingCancelview = false;
    },
    // 人员名单
    showPeopleList(row) {
      /* eslint-disable */
      // debugger
      this.$router.push({
        name: "learning-offering-registeuserlist",
        query: {
          offeringId: row.offeringId,
          offeringStatus: row.offeringStatus,
        },
        userId: row.userId,
        registeId: row.registeId,
      });
      this.$eventHub.$emit("USER_QUERY_XPY66", "");
      // alert(1)
      // this.$eventHub.$emit('showCourse', '')
    },

    dateFormat(row, column, cellValue) {
      let datetime = cellValue;
      if (datetime) {
        datetime = new Date(datetime);
        let y = datetime.getFullYear() + "-";
        let mon =
          datetime.getMonth() + 1 < 10
            ? "0" + (datetime.getMonth() + 1) + "-"
            : datetime.getMonth() + 1 + "-";
        let d =
          datetime.getDate() < 10
            ? "0" + datetime.getDate() + " "
            : datetime.getDate() + " ";
        let h =
          datetime.getHours() < 10
            ? "0" + datetime.getHours() + ":"
            : datetime.getHours() + ":";
        let min =
          datetime.getMinutes() < 10
            ? "0" + datetime.getMinutes()
            : datetime.getMinutes();
        return y + mon + d + h + min;
      }
      return "";
    },
    registformat(row, column, cellValue) {
      if (row.offeringStatus === "10") {
        return "-/" + row.maxNumber;
      }
      return row.registNumber + "/" + row.maxNumber;
    },
    demandformat(row, column, cellValue) {
      if (cellValue === "10") {
        return "未发布";
      } else if (cellValue === "20") {
        return "已发布";
      } else if (cellValue === "30") {
        return "已取消";
      } else if (cellValue === "40") {
        return "已关课";
      } else {
        return " ";
      }
    },
    GetcourseTeamCatalog(prov) {
      let tempArry = [];
      this.select2 = [];
      if (
        this.dataForm.courseTeamCatalogSecond !== null ||
        this.dataForm.courseTeamCatalogSecond === ""
      ) {
        this.dataForm.courseTeamCatalogSecond = "";
      }
      for (var val of this.allteamcatalog) {
        var code = val.code.slice(0, 2);
        if (prov === code) {
          tempArry.push({ name: val.name, code: val.code });
        }
        this.select2 = tempArry;
      }
    },
    GetcourseTeamCatalog1(prov) {
      let tempArry = [];
      this.select2 = [];
      if (
        this.dataForm.courseTeamCatalogSecond !== null ||
        this.dataForm.courseTeamCatalogSecond === ""
      ) {
        this.dataForm.courseTeamCatalogSecond = "";
      }
      for (var val of this.allteamcatalog) {
        if (prov === val.pro) {
          tempArry.push({ label: val.label, value: val.label });
        }
        this.select2 = tempArry;
      }
    },
    getcitySelectList(args) {
      let cityClass = [];
      args.forEach(function (item) {
        cityClass.push(item.regionId);
      });
      this.dataForm.cityClassList = cityClass;
    },
    // 查看
    checkShowRole(row) {
      if (this.$hasPermission("learning:offering:offeringShow")) {
        return true;
      }
      return false;
    },
    // 编辑
    checkEditRole(row) {
      if (row.offeringStatus === "30" || row.offeringStatus === "40") {
        return false;
      }
      if (this.$hasPermission("learning:offering:offeringEdit")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      if (this.$hasPermission("learning:offering:editselfcreated")) {
        return true;
      }
      return false;
    },
    // 删除
    checkDeleteRole(row) {
      if (row.offeringStatus === "40") {
        return false;
      }
      if (this.$hasPermission("learning:base:offeringinfo:delete")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      return false;
    },
    // 复制
    checkCopyRole(row) {
      if (this.$hasPermission("learning:base:offeringinfo:copyOffering")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      return false;
    },
    // 取消
    checkCancelRole(row) {
      if (row.offeringStatus !== "20") {
        return false;
      }
      if (this.$hasPermission("learning:base:offeringinfo:cancel")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      return false;
    },
    // 查看取消
    checkCancelviewRole(row) {
      if (row.offeringStatus !== "30") {
        return false;
      }
      if (this.$hasPermission("learning:base:offeringinfo:getCancelView")) {
        return true;
      }
      return false;
    },
    // 发布
    checkReleaseRole(row) {
      if (row.offeringStatus !== "10") {
        return false;
      }
      if (this.$hasPermission("learning:base:offeringinfo:release")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      return false;
    },
    // 人员名单 TA
    checkPersonnelListRole(row) {
      if (row.offeringStatus === "10") {
        return false;
      }
      if (this.$hasPermission("learning:offering:PersonnelList")) {
        return true;
      }
      if (this.$hasPermission("TEAM:" + row.courseTeamCatalogSecond)) {
        return true;
      }
      return false;
    },
    // 分配
    checkAssignUserRole(row) {
      if (row.offeringStatus !== "20") {
        return false;
      }
      if (
        row.offeringadminYN === "Y" &&
        this.$hasPermission("learning:offering:assignUser")
      ) {
        return true;
      }
      return false;
    },
    // 人员名单  经销商
    checkSeltctPersonnelListRole(row) {
      if (row.offeringStatus === "10") {
        return false;
      }
      if (this.$hasPermission("learning:base:offeringinfo:SeltctPersonnelList")) {
        return true;
      }
      return false;
    },
    // 批量更新
    onGroupUpload() {
      this.groupUpdateVisible = true;
    },
    closeCancelDlgOfferingBatchUp2() {
      this.groupUpdateVisible = false;
    },
    // 数据字典字段取值  共同不能用给未来预留
    // brandFormatter (row) {
    //   return Vue.filter('coverEnumList')(row.courseBrand, 'courseBrand', ',')
    // },
    // cstatusFormatter (row) {
    //   return Vue.filter('coverEnum')(row.coursestatus, 'coursestatus')
    // },
    // courseProjectFormatter (row) {
    //   return Vue.filter('coverEnum')(row.courseProjectCF, 'courseProjectCF')
    // },
    // courseProjectFormatter (row) {
    //   return Vue.filter('coverEnum')(row.courseKind, 'courseKind')
    // },
    // transbrand () {
    // this.dataForm.courseBrand
    // console.log(this.data.courseBrand + 'data')
    // var Str = this.dataForm.courseBrand
    // console.log(Str)
    //
    // this.dataForm.courseBrand=
    // }
  },
};
</script>
<style>
/* .courseclassroomrela .el-form-item__label {
  width: 180px !important;
  padding: 0 10px 0 0;
}
.courseclassroomrela .el-form-item__content {
  margin-left: 180px !important;
} */
</style>
<style lang="scss" scoped>
@import "../../../css/pkg-styles.css";
@import "../../../../assets/scss/modules/trainingCharge.scss";

.aui-wrapper .el-date-editor .el-range-separator {
  width: 30px;
}
.jieshu .el-form-item__content {
  width: 94.5%;
}
.kaishi .el-form-item__content {
  width: 111%;
}
.el-row {
  margin-bottom: 0px;
}
#container {
  display: -webkit-flex;
}
.el-date-editor.el-input {
  width: 150px;
}
.search-item {
  // width: 94% !important;
  // min-width: 290px;
}
.search {
  height: 50px;
}
.wrapper-div {
  .el-dialog__title {
    text-align: center;
    display: block;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
/*.btnBatchDeletion:hover {*/
/*  background: #f78989 !important;*/
/*  border-color: #f78989 !important;*/
/*  color: #fff !important;*/
/*}*/
/*.btnBatchDeletion:active {*/
/*  background: #dd6161 !important;*/
/*  background-color: rgb(221, 97, 97) !important;*/
/*  border-color: rgb(221, 97, 97) !important;*/
/*}*/
/*.btnBatchDeletion:focus {*/
/*  background: #f78989 !important;*/
/*  background-color: rgb(247, 137, 137) !important;*/
/*}*/
/*.search button:last-child {*/
/*  border-color: #f78989 !important;*/
/*}*/
//  .search-item .el-form-item__content {
//   margin-left: 96px !important;
// }
.action {
  .action-btn {
    color: rgba(37, 38, 40, 100);
    border: 0px solid rgba(223, 224, 226, 1) !important;
    background-color: rgba(28, 105, 212, 0.05) !important;
    &:hover {
      background-color: rgba(28, 105, 212, 0.2) !important;
    }
  }
}
 .el-button span {
  font-weight: 500 !important;
}
.btnColorBlack {
  color: black !important;
}
</style>
